import { render } from "./SJinventory.vue?vue&type=template&id=5539d7c4&scoped=true"
import script from "./SJinventory.vue?vue&type=script&lang=js"
export * from "./SJinventory.vue?vue&type=script&lang=js"

import "./SJinventory.vue?vue&type=style&index=0&id=5539d7c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5539d7c4"

export default script